import React from "react"
import StaticLinuxHostingBlock from "../hosting/StaticLinuxHostingBlock"
import InPrice from "../domains/InPrice"

const HeaderBanner = () => {
  return (
    <section className="position-relative pricing text-start">
      <div className="container-xl position-relative">
        <div className="row">
          <div className="col-12 col-lg-8 mb-3 mb-lg-0">
            <div className="card bg-main h-100 position-relative">
              <div className="card-body ">
                <h1 className="page-title text-white mb-4 fs-36">
                  Free Domain Name with Web Hosting
                </h1>
                <form
                  action="https://my.motherhost.com/cart.php?a=add&amp;domain=register"
                  className="row "
                  method="post"
                >
                  <div className="input-group position-relative">
                    <input
                      type="text"
                      name="sld"
                      className="form-control border-0"
                      placeholder="Let's get you that perfect Domain Name"
                    />
                    <input
                      type="submit"
                      value="Search"
                      className="btn btn-primary rounded-end"
                    />
                  </div>
                </form>
                <div className="text-white mt-3">
                  <h2 className="title">
                    <InPrice />
                  </h2>
                  <p className="text-white pb-3 description">
                    Transfer your domain name to Motherhost to extend your
                    domain by 1 year! * Free domain transfer with every hosting
                    purchase of the annual plan
                  </p>
                </div>
              </div>
            </div>
          </div>
          <StaticLinuxHostingBlock />
        </div>
      </div>
    </section>
  )
}

export default HeaderBanner
